var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** .-old/~/nwb/~/isarray/index.js
 ** module id = 31
 ** module chunks = 0
 **/